/* eslint-disable react-hooks/exhaustive-deps */
import { Button, ButtonVariant, Callout, Icon, Size } from "@blueprintjs/core"
import { HasId } from "src/libs/interfaces/layouts"
import { __ } from "src/libs/utilities"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { ILanding, ILandingContent, ILandingSection } from "src/modules/pe-landing-module/data/interfaces"
import { schema } from "src/modules/pe-landing-module/data/schema"
import { ILandingConsoleStore, ILandingStore, useLandingConsoleStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { components } from "src/modules/pe-landing-module/data/utils/components"
import { CompositeForm } from "src/modules/pe-landing-module/widgets/composite/CompositeForm"
import { PanelData } from "../../../UIX/interface"
import Panel from "../../../UIX/Panel"
import { useEffect } from "react"

/* Protopia Ecosystem component */
export interface ILayersFormProps {
   
}
const MeatForm = (props: ILayersFormProps): JSX.Element => { 
    const { meatPositions, isEdit, isMeat, isMeatTread }    = useLandingConsoleStore( (state: ILandingConsoleStore) => state )
    const { currentLanding, selectedLayer, selectedMeat}    = useLandingStore((state: ILandingStore)  => state )

    const onPosition = ( x:number, y: number, w: number, h: number ) => {
        useLandingConsoleStore.setState({meatPositions:{ x, y, w, h }})
    }
    const onThread = (bool: boolean) => {
        useLandingConsoleStore.setState({isMeatTread: bool})
    }
    
    const meat = getSelectedMeat()
    return isMeat && isEdit
        ?
        <Panel 
            x={ meatPositions?.x }
            y={ meatPositions?.y }
            w={ meatPositions?.w }
            h={ meatPositions?.h }
            isOpen={true}
            id="landing-meat"
            onClose={() => useLandingConsoleStore.setState({ isMeat: false })}
            onPosition={ onPosition }
            onThread={ onThread }
            isTread={ isMeatTread }
            header={<MeatHeader />}
            activeId="meat"
            data={
                [
                    {
                        title: __( meat && components()[meat.type] ? components()[meat.type].title : `Meat`),
                        icon: meat && components()[meat.type] ? components()[meat.type].icon : "/assets/img/landing/meat.svg",
                        data: <Meat />,
                        id: "meat"
                    } as PanelData,
                    {
                        title: __( `Float`),
                        icon: "/assets/img/landing/float.svg",
                        data: <Meat />,
                        id: "float"
                    } as PanelData,
                    {
                        title: __( `Title`),
                        icon: "/assets/img/landing/html.svg",
                        data: <Meat />,
                        id: "title"
                    } as PanelData,
                    {
                        title: __( `Background`),
                        icon: "/assets/img/landing/background.svg",
                        data: <Meat />,
                        id: "background"
                    } as PanelData,
                    {
                        title: __( `Delimiter`),
                        icon: "/assets/img/landing/divide.svg",
                        data: <Meat />,
                        id: "delimiter"
                    } as PanelData,
                ]
            }
        />
        :
        <></>
}
export default MeatForm

export const Meat = () : JSX.Element => {
    const state                 = useLandingStore((state: ILandingStore) => state)
    const meat                  = getSelectedMeat()
    const schemaData: any       = schema()[ meat?.type  || "html" ] || {}
    let schemaType              = schemaData.apollo_fields 
    const parentTypeName        = schemaData.parentType
    const parentType            = schema()[ parentTypeName ]?.apollo_fields || {}
    schemaType                  = { ...schemaType, parentType: parentTypeName, type: meat?.type,  ...parentType, }  
    const value                 = useSyncState<any>(meat)
     
    useEffect(() => {
        value.set( getSelectedMeat() ) 
    }, [state])
    
    const isCollapsesOpen: boolean[] = []
    const onCollapsesOpen = () => {}
    const onChange = (_value: any, field: string, data: any) => {
        const newVal = {
            ...value.get(),
            [field]: _value
        } 
        updateSelectedMeat(newVal)
    } 
    const form: JSX.Element =  meat
        ?
        <CompositeForm 
            schemaType={schemaType}
            origin={{}}
            value={value.get()}
            onChange={onChange}
            schemaData={schemaData}
            onCollapsesOpen={onCollapsesOpen}
            isCollapsesOpen={isCollapsesOpen}
        />
        :
        <div className="container  mx-2 width-auto">            
            <Callout className="p-4 my-3 letter-spacing-1 row width-auto">
                <div className="small col-12">
                    {__("No meat selected")}
                </div>
                <div className="micro mt-2 col-12">
                    {__("Select some meat")}
                </div>
            </Callout>
        </div>

    return <div className="landing-edit-layer"> 
        <div className="panel-list-2 overflow-y-auto"> 
            { form } 
        </div>
    </div>

}

export const MeatHeader = (): JSX.Element => {
    const { isMeatTread }     = useLandingConsoleStore( (state: ILandingConsoleStore) => state )
    
    const onTread = () => {
        useLandingConsoleStore.setState({ isMeatTread: false, meatPositions: { x: 200, y: 400, w: 280, h:390 } })
    }
    return isMeatTread 
        ?
        <div>
            <Button size={ Size.SMALL } variant={ ButtonVariant.MINIMAL } onClick={ onTread }>
                <Icon icon={ "arrow-left" } size={ 11 } color={"#FFFFFF"} />
            </Button>
        </div>
        :
        <></>
}

export const getSelectedMeat = () => {
    const state = useLandingStore.getState()
    if(!state.selectedMeat) return null
    const section = state.currentLanding.sections.find((section: HasId) => section.id === state.selectedLayer )
    if(!section) return null
    const meat: ILandingContent = section.data.find((meat: ILandingContent) => meat.id === state.selectedMeat)
    return meat 
}
//TODO: разные методы делают одно и то же MeatForm.updateSelectedMeat
export const updateSelectedMeat = (value: ILandingContent) => {
    const state = useLandingStore.getState()
    if(!state.selectedMeat) return null
    const currentLanding: ILanding = {
        ...state.currentLanding, 
        sections : state.currentLanding.sections.map((section: ILandingSection) => {
            if(section.id === state.selectedLayer) {
                return {
                    ...section,
                    data: section.data.map((meat: ILandingContent) => {
                        if(meat.id === state.selectedMeat) {
                            return value
                        }
                        return meat
                    })
                }
            }
            return section
        })
    }
    useLandingStore.setState({currentLanding}) 
}